import React, { useState , useRef, useEffect} from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import dayjs from 'dayjs'; 

const EventsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding:0;
//  align-items:center;
`;

const Card = styled.div`
  display: flex;
  flex-direction: column;
  justify-content:center;
  align-items: center;
  width: 450px;
  padding:30px 30px;
  font-size: 14px;
 color:rgb(113, 132, 138);
  text-align:center;
  overflow-y: auto; /* Allow vertical scrolling */
  overflow-x: hidden; /* Hide horizontal overflow */
  border-radius: 10px;
  background-color: #fff;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  word-wrap: break-word; /* Ensure text wraps inside the card */
  text-overflow: ellipsis; /* If needed for truncation */
  &:hover {
    transform: translateY(-5px);
  }
   
  h3{
    font-size:20px;
    margin-bottom:15px;
    color:rgb(50, 160, 194);
    font-weight: 600;
  }
`;

const CardsContainer = styled.div`
  display: flex;
  flex-wrap: wrap; /* Allow cards to wrap to the next line */
  gap: 50px; /* Space between cards */
  justify-content: center; /* Center the cards horizontally */
  padding: 50px;
`;

const Button = styled.button`
  background-color: white;
  color: #385963;
  font-weight: 400;
  border: #385963 solid 2px;
  height: 20px;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-decoration: none;
  margin-top: 10px;
  width:200px;
  height: auto;
  svg {
    margin-left: 10px;
  }

  &:hover {
    color: white;
    transition: 0.4s;
    cursor: pointer;
    background-color: #385963;
  }
`;

const UpcomingEvents = () => {

//i want all the events? 
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const selectedLanguage = sessionStorage.getItem('selectedLanguage') || 'en';
  const navigate = useNavigate();
  const loggedIn = sessionStorage.getItem("loggedIn");
  const { i18n } = useTranslation();
  const [sortedUpcomingEvents, setSortedUpcomingEvents] = useState([]);
  const tokenString = sessionStorage.getItem("token");
  const location = useLocation();
  const { state } = location;
  const [activeComponent, setActiveComponent] = useState(state?.activeComponent || '');
  // const [events, setEvents] = useState(state?.events || '');
    const [events, setEvents] = useState([]);

     useEffect(() => {
      if (state?.activeComponent) {
        setActiveComponent(state.activeComponent);
      }
      if (state?.activeComponent === '') {
          setActiveComponent('');
      }

    }, [state]);

      const handleEventNavigation = (component, eventId) => {
        navigate('/event-calendar', { state: { activeComponent: component, eventId } });
      };

    useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await fetch(`${BASE_URL}Event/searchByStartDate`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: tokenString ? `Bearer ${tokenString}` : '',
          },
          // Optional body – you can omit or change countDays as needed
          body: JSON.stringify({
            orderBy: true,
            countDays: 30,
          }),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        setEvents(data);
      } catch (error) {
        console.error('Error fetching events:', error);
      }
    };

    fetchEvents();
  }, [BASE_URL, tokenString]);

  return (
  <EventsList>
    <CardsContainer>
      {events.length === 0 ? (
        <Card>
          <h3>{i18n.t('noEventsFound') || 'No upcoming events found.'}</h3>
        </Card>
      ) : (
        events.map((currentEvent) => {
          // use correct property names
          let eventStart = new Date(currentEvent.startDate);
          let eventEnd = new Date(currentEvent.endDate);

          let formattedStart = eventStart.toLocaleString(selectedLanguage, {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
          });

          let formattedEnd = eventEnd.toLocaleString(selectedLanguage, {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
          });

          return (
            <Card key={currentEvent.id}>
              <h3>{currentEvent.name?.[selectedLanguage] || currentEvent.providerName}</h3>
              <p>
                <strong>{i18n.t('startDate')}:</strong> <div>{formattedStart}</div>
              </p>
              <p>
                <strong>{i18n.t('endDate')}:</strong> <div>{formattedEnd}</div>
              </p>
              <Button onClick={() => handleEventNavigation('eventDetails', currentEvent.id)}>
                {i18n.t('eventDetails')}
              </Button>
            </Card>
          );
        })
      )}
    </CardsContainer>

    <Button
      style={{ placeSelf: 'center' }}
      onClick={() =>
        events.length === 0
          ? navigate('/event-calendar', { state: { activeComponent: 'calendar' } })
          : handleEventNavigation('eventDetails')
      }
    >
      {i18n.t('back')}
    </Button>
  </EventsList>
);


}

export default UpcomingEvents

